import DateRangeOutlinedIcon from "@mui/icons-material/DateRangeOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import PeopleOutlineOutlinedIcon from "@mui/icons-material/PeopleOutlineOutlined";
import TimelineIcon from "@mui/icons-material/Timeline";
import {
  Box,
  Button,
  IconButton,
  Switch,
  Tooltip,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSuperAdminSuscripts } from "../../../context/SuperAdmin/SuscriptsContext";
import { Estado } from "../../../interfaces/SuperAdmin/Others/iDataEstado";
import {
  iDataSuscripcionOrg,
  PutSuscriptFields,
} from "../../../interfaces/SuperAdmin/Pages/iDataSuscripcion";
import {
  StyledTableCell,
  StyledTableRow,
} from "../../../ui-components/StyledTables";
import { esFechaFutura, formatFecha } from "../../../utils/dateFunctions";
import { useAuthContext } from "../../../hooks/Auth";

interface SuscripRowProps {
  suscription: iDataSuscripcionOrg;
  i: number;
}

export const ProfileRowSuscriptOrg: React.FC<SuscripRowProps> = ({
  suscription,
  i,
}) => {
  const { plan, fecha_inicio, fecha_fin, id_suscripcion, created_at, estado } =
    suscription;

  const [isActive, setIsActive] = useState(estado === Estado.ACTIVO);
  const { assignToDeleteSuscr, handleEdit, editSuscription } =
    useSuperAdminSuscripts();

  const { canAccess } = useAuthContext();

  useEffect(() => {
    setIsActive(estado === Estado.ACTIVO);
  }, [suscription]);

  const toggleActive = async () => {
    const body = { estado: isActive ? Estado.INACTIVO : Estado.ACTIVO };
    editSuscription(id_suscripcion, body as PutSuscriptFields);
  };

  const canChangeDate = esFechaFutura(fecha_inicio);

  return (
    <StyledTableRow sx={{ opacity: estado === Estado.VENCIDO ? 0.5 : 1 }}>
      <StyledTableCell sx={{ mb: 2 }}>{i}</StyledTableCell>
      <StyledTableCell sx={{ mb: 4 }}>
        <Box
          sx={{
            py: 1.5,
            px: 2,
            borderRadius: "8px",
            backgroundColor: "#F9BA3280",
            color: "#6A93A8",
            textAlign: "center",
            fontWeight: 700,
            fontSize: 16,
          }}
        >
          {plan}
        </Box>
      </StyledTableCell>
      <StyledTableCell>{new Date(created_at).toLocaleString()}</StyledTableCell>
      <StyledTableCell>{formatFecha(fecha_inicio)}</StyledTableCell>
      <StyledTableCell>{formatFecha(fecha_fin)}</StyledTableCell>

      {/* En caso de que se pueda editar */}
      {canAccess("edit:suscriptions") ? (
        <StyledTableCell sx={{ mb: 4 }}>
          {estado !== Estado.VENCIDO ? (
            <Tooltip
              title={
                esFechaFutura(fecha_inicio)
                  ? "No se puede activar una suscripción que aún no ha empezado"
                  : ""
              }
              arrow
            >
              <span>
                <Switch
                  checked={isActive}
                  onChange={toggleActive}
                  disabled={esFechaFutura(fecha_inicio)}
                  sx={{
                    "& .MuiSwitch-switchBase.Mui-checked": {
                      color: "#2E7D32",
                    },
                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                      backgroundColor: "#2E7D32",
                    },
                  }}
                />
              </span>
            </Tooltip>
          ) : (
            <Typography>{estado}</Typography>
          )}
        </StyledTableCell>
      ) : (
        <StyledTableCell>{estado}</StyledTableCell>
      )}

      {/* Botones de acción */}
      <StyledTableCell align="center">
        {canAccess("edit:suscriptions") && (
          <Button
            sx={{ color: "#336B87", opacity: canChangeDate ? 1 : 0.5 }}
            disabled={!canChangeDate}
            onClick={() => handleEdit(suscription)}
          >
            <Tooltip title="Cambiar fecha de inicio">
              <IconButton sx={{ color: "#336B87" }}>
                <DateRangeOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Button>
        )}
        {canAccess("delete:suscriptions") && (
          <Button
            sx={{ color: "#336B87" }}
            onClick={() => assignToDeleteSuscr(suscription.id_suscripcion)}
          >
            <Tooltip title="Eliminar suscripción">
              <IconButton aria-label="delete" sx={{ color: "#336B87" }}>
                <DeleteOutlineOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Button>
        )}
        <Link to={`${suscription.id_suscripcion}`}>
          <Button sx={{ color: "#336B87" }}>
            <Tooltip title="Gestionar usuarios">
              <IconButton aria-label="usuarios" sx={{ color: "#336B87" }}>
                <PeopleOutlineOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Button>
        </Link>
        <Link to={`${suscription.id_suscripcion}/credits`}>
          <Button sx={{ color: "#336B87" }}>
            <Tooltip title="Uso de créditos">
              <IconButton aria-label="créditos" sx={{ color: "#336B87" }}>
                <TimelineIcon />
              </IconButton>
            </Tooltip>
          </Button>
        </Link>
      </StyledTableCell>
    </StyledTableRow>
  );
};
